import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { APPLICATIONSERVICE } from "../../constants/application-service";
import { MICROSERVICES } from "../../constants/web-services";
import { AppBaseService } from "../../services/http.service";
import { MatDialog } from "@angular/material/dialog";
import { ReportService } from "../../services/report.service";
import { AuthService } from "../../services/auth.service";
import { printExport } from "../../enums/configuration-modules.enum";
import { MultiLanguageService } from "../multi-language/multi-language.service";
declare const PDFObject: any;

@Component({
  selector: 'lib-pdf-viewer4',
  templateUrl: './pdf-viewer4.component.html',
  styleUrl: './pdf-viewer4.component.scss'
})
export class PdfViewer4Component implements OnInit, OnDestroy {
  protected _onDestroy = new Subject<void>();
  reportPayload: any;
  componentLoaded: boolean = false;
  userRightList: any= [];
  exportFlag: boolean= false;
  languageList: any[]=[];
  selectedLanguageCode: string = 'en';
  selected: any;  
  exportTypes = [
    { id: '1', active: true, code: 'xlsx', desc: 'Excel' },
    { id: '2', active: true, code: 'doc', desc: 'DOC' },
    { id: '3', active: true, code: 'csv', desc: 'CSV' }
  ];
  reportSecondPayload: any;
  language: string="";
  patientRegistrationForm:any;

  constructor(
    private httpService: AppBaseService,
    public dialog: MatDialog,
    private reportService: ReportService,
    public authService: AuthService,
    private langService: MultiLanguageService,
  ) {}

  ngOnInit(): void {
    // localStorage.setItem("lan", "en");
    this.language= localStorage.getItem("lan") || "en";
    this.componentLoaded = true;
    this.getUserInfo();
    this.reportPrint();
    this.getlanguagedata();
  }
  getlanguagedata() {
    this.langService.getLanguageListPromise().then((data: any[]) => {
      this.languageList = data;
  
      const defaultLanguage = this.languageList.find(lang => lang?.code.toLowerCase() === this.language.toLowerCase());
      this.selected = defaultLanguage ? defaultLanguage : this.languageList[0];
      this.selectedLanguageCode = this.mapLanguageToCode(this.selected.desc);
      localStorage.setItem("lan", this.selectedLanguageCode);

    });
  }
  
  changeLanguage(event: any) {
    this.selected = event.value;
    this.selectedLanguageCode = this.mapLanguageToCode(this.selected.desc);
    localStorage.setItem("lan", this.selectedLanguageCode);
  
    this.reportPrint();
  }
  
  mapLanguageToCode(language: string): string {
    switch (language) {
      case 'English': return 'en';
      case 'Malay': return 'my';
      case 'Thai': return 'th';
      default: return 'en';
    }
  }
  
  getUserInfo() {
    const reportPayload = localStorage.getItem("reportPayload");
    const isFromMis = reportPayload ? JSON.parse(reportPayload)?.isFromMis ?? false : false;
  
    if (isFromMis) {
      this.exportFlag = true;
      return;
    }
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == printExport.printExport)
            this.exportFlag = true;
        });
      }
    });
}
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    localStorage.removeItem("pdpaformPayload");
    localStorage.removeItem("billingSReportPayload");
  }

  reportPrint() {
    this.reportPayload = JSON.parse(localStorage.getItem("pdpaformPayload"));
    this.patientRegistrationForm=JSON.parse(localStorage.getItem("PatientRegistrationForm"));
     this.reportSecondPayload = JSON.parse(localStorage.getItem("billingSReportPayload"));

    if (!this.reportPayload && !this.reportSecondPayload) {
      console.error("No report payload found in local storage.");
      return;
    }else if(this.reportSecondPayload && this.reportSecondPayload.isBilling) {
      if(this.reportSecondPayload) {
        this.multipleBillingReportsAPI(this.reportSecondPayload)
        localStorage.removeItem("billingSReportPayload");
        this.reportSecondPayload=null;
      } 
    } else {
      if(this.patientRegistrationForm){
        this.multipleReportsAPI(this.patientRegistrationForm);
      }else{this.multipleReportsAPI(this.reportPayload);}
      
    }
  }

  reportPrintAPI(resourceUrl: string, reportGeneratePath: string, reqPayload: any) {
    this.httpService.setResourceURL(resourceUrl);
    this.httpService
      .postResource(reportGeneratePath, reqPayload)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((result: any) => {
         if(result.payload) {
        //console.log(result.payload);
       
        // Remove the prefix "data:application/pdf;base64,"
        const base64Data = result.payload.split(",")[1];

        // Convert base64 -> binary -> Blob
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: "application/pdf" });

        // Create a temporary object URL
        const fileURL = URL.createObjectURL(file);
        PDFObject.embed(fileURL, "#pdfContainer");
        }
        // PDFObject.embed(result.payload, "#pdfContainer");
        if (!this.componentLoaded) {
          window.location.reload();
        }
      });
  }
  multipleReportsAPI(payLoad: any) {
    const reqPayload = this.formatGenericReportPayload(payLoad);
    this.reportPrintAPI(
      MICROSERVICES.OPD_SERVICE,
      APPLICATIONSERVICE.REPORT_GENERATE_VIEW,
      reqPayload
    );
  }

  formatGenericReportPayload(report: any): any {
    return {
      transactionId: report.transactionId,
      type: report.type,
      reportName: report.reportName
    };
  }
  exportfile(valuelist) {
    this.reportPayload = JSON.parse(localStorage.getItem("pdpaformPayload"));
    if(this.reportPayload==null || this.reportPayload==undefined){
    this.reportPayload=JSON.parse(localStorage.getItem("PatientRegistrationForm"));
    }
    if(this.reportPayload==null || this.reportPayload==undefined){
    this.reportPayload = JSON.parse(localStorage.getItem("billingSReportPayload"));
    }
  
    const fileTypeMap = { 1: "xlsx",2: "docx",3: "csv"};  
    if (fileTypeMap[valuelist.id]) {
      this.exportfileType(fileTypeMap[valuelist.id]);
    } else {
      this.reportService.printReport(
        this.reportPayload.transactionId,
        this.reportPayload.type,
        this.reportPayload.reportName
      );
    }
  }
  
  /**
   * Exports the file based on the report type.
   *
   * @param {string} fileType
   */
  exportfileType(fileType: string) {
    if (!this.reportPayload) return;
      const {isReports,isBilling,isStock,
      isDietKitchen,isLab,isBarcode,transactionId,
      reportName,reprint,params,parameterList
    } = this.reportPayload;
  
    if (isReports) {
      this.reportPayload.type = fileType;
      this.reportService.printMISReport(this.reportPayload, fileType, reportName);
    } else if (isBilling) {
      this.reportService.printReportBillingExport(transactionId, fileType, reportName, reprint, params || []);
    } else if (isStock || isDietKitchen) {
      this.reportService.printReportStock(this.reportPayload, fileType, reportName, false);
    } else if (isLab) {
      if (isBarcode) {
        this.reportService.printReportLabBarcode(parameterList, fileType, reportName);
      } else {
        this.reportService.printReportStock(this.reportPayload, fileType, reportName, true);
      }
    } else {
      this.reportService.printReport(transactionId, fileType, reportName);
    }
  }
   multipleBillingReportsAPI = (payLoad: any) => {
    let payloadres="";
    let requestPayload;
    payloadres=payLoad;
    return new Promise<void>((resolve) => {
        requestPayload = this.formatBillingReportPayload(payloadres);

      this.reportPrintAPI(
        MICROSERVICES.BILLING_SERVICE,
        APPLICATIONSERVICE.REPORT_GET_COMMON_REPORT,
        requestPayload,
      );
      resolve();
    });
  };  
  formatBillingReportPayload(reportPayload): any {
    const requestPayload = {
      type: reportPayload.type,
      reportName: reportPayload.reportName.toUpperCase(),
      parameterList: [
        {
          parameter: "id",
          value: reportPayload.transactionId,
          dataType:"Long"
        },
        {
          parameter: "isReprint",
          value: reportPayload.reprint,
          dataType:"Boolean"
        }
      ]
    }

    if(reportPayload.params && reportPayload.params.length > 0) {
      reportPayload.params.forEach(param => {
        requestPayload.parameterList.push({
          parameter: param.name.toLowerCase(),
          value: param.value,
          dataType: param.dataType
        });
      });
    }

    return requestPayload;
  }
}

